export * from "@vaadin/icon/vaadin-iconset.js";
export * from './generated/Iconset.js';
